import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=210649a2&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=210649a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210649a2",
  null
  
)

export default component.exports